import { render } from "./IndexUsers.vue?vue&type=template&id=498f0d4e"
import script from "./IndexUsers.vue?vue&type=script&lang=js"
export * from "./IndexUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__